import React from "react";
import avatar from "./avatar.svg";
import collapseButton from "./collapse-button.svg";
import closeIcon from "./close-icon.svg";
import uploadFile from "./upload-file.svg";
import closedCollapse from "./green-plus.svg";
import collapseAll from "./collapse-all.svg";
import DocumentIcon from "./DocumentIcon";
import Document2Icon from "./Document2Icon";
import PdfIcon from "./PdfIcon";
import PlusExpand from "./PlusExpand";
import NaturalPersonIcon from "./NaturalPersonIcon";
import LegalEntityIcon from "./LegalEntityIcon";
import DateIcon from "./DateIcon";
import Branding from "./Branding";
import CollapseOpenIcon from "./CollapseOpenIcon";
import SmallLogo from "./SmallLogo";
import ErrorIcon from "./ErrorIcon";
import SuccessIcon from "./SuccessIcon";
import WarningIcon from "./WarningIcon";

export const Avatar = () => <img alt="." src={avatar} />;
export const CollapseButton = () => <img alt="." src={collapseButton} />;

export const CloseIcon = () => <img alt="." src={closeIcon} />;
export const UploadFile = () => <img alt="." height={25} src={uploadFile} />;
export const ClosedCollapse = ({ className = "" }) => (
  <img alt="." className={className} width={20} height={20} src={closedCollapse} />
);
export const CollapseAll = () => <img alt="." height={14} src={collapseAll} />;

export {
  DocumentIcon,
  PdfIcon,
  PlusExpand,
  NaturalPersonIcon,
  LegalEntityIcon,
  DateIcon,
  Document2Icon,
  Branding,
  CollapseOpenIcon,
  SmallLogo,
  ErrorIcon,
  SuccessIcon,
  WarningIcon,
};



// WEBPACK FOOTER //
// ./src/assets/index.js